"use client"

import { useEffect, useRef } from "react"
import Chart from "chart.js/auto"
import "./ResultsChart.css"

const ResultsChart = ({ results }) => {
  const chartRef = useRef(null)
  const chartInstance = useRef(null)

  useEffect(() => {
    if (!results || !results.data || results.data.length === 0) return

    // Destroy previous chart if it exists
    if (chartInstance.current) {
      chartInstance.current.destroy()
    }

    const ctx = chartRef.current.getContext("2d")

    // Prepare data for the chart
    const labels = results.data.map((day) => new Date(day.date).toLocaleDateString())

    const datasets = results.models.map((model, index) => {
      // Generate a color based on the index
      const hue = (index * 137) % 360 // Use golden angle approximation for good distribution
      const color = `hsl(${hue}, 70%, 60%)`

      return {
        label: model.name,
        data: results.data.map((day) => day.etref[model.id] || null),
        borderColor: color,
        backgroundColor: `${color}33`, // Add transparency
        tension: 0.3,
        pointRadius: 3,
        pointHoverRadius: 5,
      }
    })

    // Create the chart
    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels,
        datasets,
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            mode: "index",
            intersect: false,
            callbacks: {
              label: (context) => `${context.dataset.label}: ${context.raw ? context.raw.toFixed(2) : "N/A"} mm/day`,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "Date",
            },
          },
          y: {
            title: {
              display: true,
              text: "WATref (mm/day)",
            },
            beginAtZero: true,
          },
        },
      },
    })

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy()
      }
    }
  }, [results])

  if (!results || !results.data || results.data.length === 0) {
    return <div className="no-results">No data available for chart</div>
  }

  return (
    <div className="results-chart-container">
      <h3>WATref Comparison Chart</h3>
      <div className="chart-wrapper">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  )
}

export default ResultsChart
